/**
 * 急速赛马动画容器
 */
import React, { Component, PropTypes } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as lotteryAction from '../../actions/lotteryAction'
import * as baseAction from '../../actions/baseAction'
import Car from './Car.jsx'
import RankBox from './RankBox.jsx'
import CountDown from './CountDown.jsx'
import TopThree from './TopThree.jsx'
import Loader from '../icon/Loader.jsx'
import {ANIMATE_AREA} from '../../constants/lotterys/animateAreaCofig'

class Pk10Container extends React.Component {

  constructor(props) {
    super(props);
    this.startRun = this.startRun.bind(this);
    this.makeAnimation = this.makeAnimation.bind(this);
    this.cycleAnimation = this.cycleAnimation.bind(this);
    this.countdown = this.countdown.bind(this);
    this.horse = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10']
    this.state = {
      // 5种状态 -1: 还没开始显示 0: 倒计时开跑 1: 正在跑 2: 开奖显示冠亚军 3: 错误
      ranks: null,
      rankCode: [],
      issue: '000000',
      status: -1
    }
    // 动画显示状态对应时间区间
    this.animateArea = ANIMATE_AREA[this.props.alias];
  }

  componentDidMount(){
    this.makeAnimation(this.props);
  }

  componentWillUnmount(){
    if (this.rankTimer) {window.clearInterval(this.rankTimer)}
    if (this.countdownTimer) {window.clearTimeout(this.countdownTimer)}
  }

  componentWillReceiveProps(nextProps) {
    // 还没加载完
    const __window = nextProps.__METHOD.toJS().windows[nextProps.windowId];
    const __oldWindow = this.props.__METHOD.toJS().windows[nextProps.windowId];
    if (!__window.current_issue || !__window.current_issue.current || !__window.current_issue.history) {
      return;
    }
    const { current, history, countdown} = __window.current_issue;
    // 第一次加载
    if (this.state.status == -1) {
      this.animateArea = ANIMATE_AREA[nextProps.alias];
      this.cycleAnimation(nextProps, countdown);
      return;
    }
    // 切换了彩种
    if (this.props.alias != nextProps.alias) {
      this.animateArea = ANIMATE_AREA[nextProps.alias];
      this.cycleAnimation(nextProps, countdown);
      return;
    }
    // 如果倒计时变了，矫正倒计时
    if (countdown != __oldWindow.current_issue.countdown) {
      this.cycleAnimation(nextProps, countdown);
      return;
    }

  }

  // 初始化动画
  cycleAnimation(props, countdown){
    const { setIssue } = this.props;
    const {cycle, delay} = this.animateArea;
    // 倒计时没变，推送了新奖期
    if (!countdown && countdown != 0) {
      countdown = this.state.countdown;
    }
    const __window = props.__METHOD.toJS().windows[this.props.windowId];
    const { current, history} = __window.current_issue;
    // 开始倒计时
    this.countdown(countdown);
    const _realCountDown = countdown;
    this.setState({
      countdown: (_realCountDown >= (cycle - delay) && _realCountDown <= cycle) ? _realCountDown - (cycle-delay) : _realCountDown + delay
    })
    // 倒计时
    if (_.includes(this.animateArea.countdown, _realCountDown)) {
      if (this.rankTimer) {window.clearInterval(this.rankTimer); this.rankTimer=null;}
      this.setState({
        status: 0,
        issue: history.issue,
        ranks: history.split_code,
      })
      setIssue(history.issue);
      return;
    }
    // 跑马
    const formatCurrentIssue = _.includes(current.issue, '-') ? current.issue.split('-')[1] : parseInt(current.issue);
    const formatHistoryIssue = _.includes(history.issue, '-') ? history.issue.split('-')[1] : parseInt(history.issue);
    if (_.includes(this.animateArea.run, _realCountDown) && formatCurrentIssue - formatHistoryIssue > 1) {
      this.setState({
        status: 1,
        issue: formatCurrentIssue - 1,
        rankCode: []
      })
      this.delaySecond = 1;
      this.startRun();
      setIssue(_.includes(current.issue, '-') ? current.issue.split('-')[0] + '-' + (formatCurrentIssue - 1) : formatCurrentIssue - 1);
      return;
    }
    // 显示前三名
    if (_.includes(this.animateArea.winner, _realCountDown) && formatCurrentIssue -  formatHistoryIssue == 1) {
      this.delaySecond ++;
      if (this.delaySecond <= 4) {
        this.setState({
          rankCode: history.split_code
        })
        return;
      }
      if (this.rankTimer) {window.clearInterval(this.rankTimer); this.rankTimer=null;}
      this.setState({
        status: 2,
        ranks: history.split_code,
        issue: history.issue
      })
      setIssue(history.issue);
      return;
    }
    // 错误
    if (_.includes(this.animateArea.error, _realCountDown) && formatCurrentIssue - formatHistoryIssue > 1) {
      if (this.rankTimer) {window.clearInterval(this.rankTimer); this.rankTimer=null;}
      this.setState({
        status: 3,
        ranks: history.split_code,
        issue: history.issue
      })
      setIssue(history.issue);
    }
  }

  // 倒计时
  countdown(countdown,){
    if (this.countdownTimer) {window.clearTimeout(this.countdownTimer)}
    this.countdownTimer = window.setTimeout(function(){
      this.cycleAnimation(this.props, countdown == 0 ? (this.animateArea.cycle-1) : countdown -1)
    }.bind(this), 1000)
  }


  // 开始跑马
  startRun(){
    if (this.rankTimer) {return;}
    // 开启计时器定时查看名次
    this.rankTimer = window.setInterval(function(){
      const horse = document.querySelectorAll('.car-am');
      const ranks = _.chain(horse).sortBy('offsetLeft').map((item) => _.last(_.split(item.className, 'no'))).value();
      this.setState({
        ranks: ranks
      })
    }.bind(this), 200)
  }

  // 生成显示动画区
  makeAnimation(){
    const __window = this.props.__METHOD.toJS().windows[this.props.windowId]
    // 未开始显示
    if (this.state.status == -1) {
      return <ReactCSSTransitionGroup 
                transitionAppear={true}
                transitionEnterTimeout={500} 
                transitionLeaveTimeout={500} 
                transitionAppearTimeout ={500} 
                transitionName='opacity'>
               <div className='road-bg'>
                 <Loader />
               </div>
             </ReactCSSTransitionGroup>
    }
    // 倒计时
    if (this.state.status == 0) {
      return <ReactCSSTransitionGroup 
                transitionAppear={true}
                transitionEnterTimeout={500} 
                transitionLeaveTimeout={500} 
                transitionAppearTimeout ={500} 
                transitionName='opacity'>
               <div className='road-bg'>
                 <CountDown time={this.state.countdown} className='countdown' />
               </div>
             </ReactCSSTransitionGroup>
    }
    // 正在跑
    if (this.state.status == 1) {
      return <ReactCSSTransitionGroup 
                transitionAppear={true} 
                transitionEnterTimeout={500} 
                transitionLeaveTimeout={500} 
                transitionAppearTimeout ={500} 
                transitionName='opacity'>
                <div className='road-bg run'>
                  {_.map(this.horse, (item, index) => <Car rank={_.indexOf(this.state.rankCode, item)} no={item} key={index} />)}
                </div>
                {
                  this.state.rankCode.length == 10 ? <div className='end-line' /> : null
                }
              </ReactCSSTransitionGroup>
    }
    // 开奖
    if (this.state.status == 2) {
      return <TopThree rank={this.state.ranks} />
    }
    // 错误状态
    if (this.state.status == 3) {
      return <ReactCSSTransitionGroup 
                transitionAppear={true}
                transitionEnterTimeout={500} 
                transitionLeaveTimeout={500} 
                transitionAppearTimeout ={500} 
                transitionName='opacity'>
               <div className='road-bg'>
                 <div className='error'>动画显示出现异常，请刷新页面</div>
               </div>
             </ReactCSSTransitionGroup>
    }
  }


  render() {
    const __window = this.props.__METHOD.toJS().windows[this.props.windowId]
    const display = this.props.__BASE.toJS().config.showBetAnimation;
    const {sizeMode} = this.props;
    return (
      <div className={__window?'pk10-animation ' + __window.flag + ' ' + sizeMode.className:'pk10-animation ' + sizeMode.className}>
        <RankBox issue={this.state.issue} rank={this.state.ranks} alais='pk10' status={this.state.status}/>
        {
          this.makeAnimation()
        }
      </div>
    ); 

  }
}

reactMixin(Pk10Container.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __USER: state.user,
    __METHOD: state.method
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Pk10Container)